import { render, staticRenderFns } from "./SpyderFeedView.vue?vue&type=template&id=1959fcf9&scoped=true"
import script from "./SpyderFeedView.vue?vue&type=script&lang=js"
export * from "./SpyderFeedView.vue?vue&type=script&lang=js"
import style0 from "./SpyderFeedView.vue?vue&type=style&index=0&id=1959fcf9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959fcf9",
  null
  
)

export default component.exports